import React from "react";
import { twMerge } from "tailwind-merge";

// Common form styles used across components
export const formStyles = {
  label:
    "text-[#FFFFFF] font-public-sans font-medium text-[1.0625rem] text-left mb-[10px]",
  dropDownlabel:
    "text-[#FFFFFF] font-public-sans font-medium text-[14px] text-left mb-[10px]",
  helpText:
    "text-[#686868]  text-[8px] sm:text-[.6875rem] font-public-sans font-normal mb-2 text-left mt-1",
  errorText:
    "text-[#FF0000] text-[8px] sm:text-[12px] font-inter font-normal leading-[12px] block",
  errorContainer: "min-h-4 text-left",
  requiredStar: "text-[#C00707]",
  input:
    "w-full h-10 rounded-md font-public-sans font-normal text-[10px] sm:text-[.9375rem] text-[#686868] bg-[#262530] placeholder:text-[#686868] placeholder:text-opacity-80 focus:outline-none px-4 py-3",
  dropDown:
    "w-full flex items-center justify-between px-4 py-3 bg-[#45444433] text-[#808080] font-normal font-public-sans text-sm rounded-md placeholder-[#808080]",
  dropDownOptions:
    "w-full flex items-center justify-between px-4 py-3 bg-[#262530] text-[#686868] font-normal font-public-sans text-sm  placeholder-[#686868] placeholder-opacity-80 my-[1px]",
  customerApplicationlabel:
    "text-[#E3E3E3] text-[14px] font-public-sans font-normal leading-[22px] mb-[5px]",
  customerApplicationInput:
    "bg-[#45444433] border border-[#808080] rounded-[5px] h-[45px] rounded-[5px] pl-[15px]",
  remixerApplicationlabel:
    "text-[#808080] text-[14px] font-public-sans font-normal leading-[22px] mb-[5px]",
  remixerApplicationInput:
    "bg-[#45444433] border border-[#81818180] rounded-[5px] h-[35px] rounded-[5px] pl-[15px] text-[#E3E3E3] text-[14px] leading-[22px] font-public-sans font-normal",
  addTrackInput:"bg-[#45444433] text-[#808080] placeholder:text-[#808080] placeholder:text-[14px] h-[45px] text-[14px]",
};

/**
 * FormLabel - Reusable label component with consistent styling
 */
export const FormLabel = ({
  htmlFor,
  label,
  isRequired,
  className,
  helpText,
}) => {
  if (!label) return null;

  return (
    <label
      htmlFor={htmlFor}
      className={twMerge(
        formStyles.label,
        helpText ? "mb-0" : "mb-[.625rem]",
        className
      )}
    >
      {label} {isRequired && <span className={formStyles.requiredStar}>*</span>}
    </label>
  );
};

/**
 * FormHelperText - Reusable helper text component with consistent styling
 */
export const FormHelperText = ({
  helpText,
  error,
  className,
  errorClassName,
}) => {
  return (
    <div className={twMerge(formStyles.errorContainer, className)}>
      {helpText && !error && (
        <span className={formStyles.helpText}>{helpText}</span>
      )}
      {error && (
        <span className={twMerge(formStyles.errorText, errorClassName)}>
          {error}
        </span>
      )}
    </div>
  );
};
